<template>
  <div>
    <div class="six">
      <div class="publictitle">
        <p class="pli">联系我们</p>
        <!-- <p class="pli1">Contact us</p> -->
      </div>

      <!-- <img class="liucheng" src="../assets/images/23.jpg" alt="" /> -->
      <div class="inner fl">
        <div style="width: 470px">
          <div class="dar">大儒心理咨询中心</div>
          <div style="margin-top: 18px" v-html="phone"></div>
        </div>
        <div id="container"></div>
      </div>
    </div>
    <div class="seven">
      <div class="publictitle">
        <p style="color: #fff" class="pli">友情链接</p>
        <!-- <p style="color: #fff" class="pli1">Friendship links</p> -->
      </div>

      <div class="inner imglist clearfix">
        <div @click="open(item)" v-for="(item, index) in linkList" :key="index">
          {{ item.title }}
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      linkList: [],
      phone: null,
      map: null,
    };
  },
  mounted() {
    document.getElementById("container").innerHTML = "";
    //获取友情链接
    this.getLink();
    this.getus();
    this.getLat();
  },
  methods: {
    open(e) {
      window.open(e.url);
    },
    getLink() {
      this.$get("/web/api/list_link", {}).then((res) => {
        if (res.code == 200) {
          this.linkList = res.data;
          console.log(res.data);
        }
      });
    },
    getus() {
      this.$get("/web/api/get_lx_us_txt", {}).then((res) => {
        if (res.code == 200) {
          this.phone = res.data;
        }
      });
    },
    getLat() {
      this.$get("/web/api//get_lng_lat", {}).then((res) => {
        if (res.code == 200) {
          var lnt = res.data.split(",")[1];
          var lat = res.data.split(",")[0];
          //初始化地图
          this.getMap(lnt, lat);
        }
      });
    },
    getMap(lnt, lat) {
      var center = new TMap.LatLng(lnt, lat);
      //定义map变量，调用 TMap.Map() 构造函数创建地图
      this.map = new TMap.Map(document.getElementById("container"), {
        center: center, //设置地图中心点坐标
        zoom: 12, //设置地图缩放级别
        pitch: 43.5, //设置俯仰角
        rotation: 45, //设置地图旋转角度
      });
      var markerLayer = new TMap.MultiMarker({
        map: this.map,
        styles: {
          myStyle: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            src: "https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png", //图片路径

            anchor: { x: 16, y: 32 },
          }),
        },
        //点标记数据数组
        geometries: [
          {
            id: "1",
            styleId: "myStyle",
            position: new TMap.LatLng(lnt, lat), //点标记坐标位置
            properties: {
              //自定义属性
              title: "marker1",
            },
          },
        ],
      });
    },
    destroy() {
      this.map.destroy();
      this.map = null;
    },
  },
};
</script>

<style  scoped>
.six {
  padding: 50px 0;
  background-color: #eff9f8;
}
.seven {
  padding: 50px 0;
  background-color: #898989;
}
.publicimg {
  margin: 0 auto 30px;
  display: block;
}
.fl {
  justify-content: space-between;
  display: flex;
}
#container {
  display: block;
  width: 660px;
  height: 385px;
}
.dar {
  padding: 0px 0 22px;
  border-bottom: 1px solid #7d7d7d;
  font-size: 24px;
}
.imglist img {
  display: block;
  width: 230px;
  height: 107px;
  margin-right: 20px;
  float: left;
  margin-bottom: 20px;
}
.imglist div {
  display: block;
  width: 123px;
  cursor: pointer;
  float: left;
  margin-bottom: 20px;
  color: #fff;

}
.imglist > div:nth-child(10n) {
  margin-right: 0;
}
</style>